import { Box, Typography, Button, Card } from '@material-ui/core'

import useStyles from '../../styles'

const WaitingApprovalCard = ({
  handleOpenDesk = () => {},
  goBack = () => {},
}) => {
  const WAITING_APPROVAL_STATUS_TEXT_INFO =
    'Sua solicitação de cadastro em nosso sistema esta sendo analisada pela nossa equipe ' +
    'quando seu cadastro for aprovado você poderá utilizar a plataforma. Caso possua alguma ' +
    'dúvida entre em contato conosco. '
  const classes = useStyles()

  return (
    <Card>
      <Box m={3} maxWidth="500px" alignContent="justify">
        <Box mb={2}>
          <Typography variant="h4">Aguardando aprovação</Typography>
        </Box>
        <Typography align="justify">
          {WAITING_APPROVAL_STATUS_TEXT_INFO}
        </Typography>
        <Box mt={2} className={classes.buttonContainer}>
          <Button variant="contained" color="primary" onClick={goBack}>
            Voltar
          </Button>
          <Button onClick={handleOpenDesk} className={classes.buttonSpacing}>
            Entrar em contato
          </Button>
        </Box>
      </Box>
    </Card>
  )
}

export default WaitingApprovalCard
